import "./worldClocks.scss";
import { useEffect, useState } from "react";
import Clock from "react-clock";
import "react-clock/dist/Clock.css";
import moment from "moment-timezone";
import { newExpression } from "@babel/types";
import Clocks from "../Clocks";

const WorldClocks = () => {
  function convertTZ(date, tzString) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );
  }

  const [value, setValue] = useState(convertTZ(new Date(), "Asia/Tehran"));
  const [value2, setValue2] = useState(convertTZ(new Date(), "Asia/Istanbul"));
  const [value3, setValue3] = useState(
    convertTZ(new Date(), "America/New_York")
  );
  const [value4, setValue4] = useState(convertTZ(new Date(), "Asia/Dubai"));

  useEffect(() => {
    const interval1 = setInterval(function () {
      setValue(convertTZ(new Date(), "Asia/Tehran"));
    }, 1000);
    const interval2 = setInterval(function () {
      setValue2(convertTZ(new Date(), "Asia/Istanbul"));
    }, 1000);

    const interval3 = setInterval(function () {
      setValue3(convertTZ(new Date(), "America/New_York"));
    }, 1000);
    const interval4 = setInterval(function () {
      setValue4(convertTZ(new Date(), "Asia/Dubai"));
    }, 1000);

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
      clearInterval(interval3);
      clearInterval(interval4);
    };
  }, []);

  return (
    <>
      <section className="clock-container">
        <div className="trapezoid-parent">
          <div className="trapezoid-child clocks">
            {/* <div className="clock-item">
                            <Clock value={value} />
                            <div className="clock-label">تهران</div>
                        </div>  */}

            <div>
              <Clocks title="دبی" datediff={0} minutesdiff={35} />
            </div>
            <div>
              <Clocks title="استانبول" datediff={0} minutesdiff={-25} />
            </div>
            <div>
              <Clocks title="نیویورک" datediff={-7} minutesdiff={-25} />
            </div>
            <div>
              <Clocks title="تهران" datediff={0} minutesdiff={0} />
            </div>

            {/* <div className="clock-item">
                            <Clock value={value2} />
                            <div className="clock-label">استانبول</div>
                        </div>
                        <div className="clock-item">
                            <Clock value={value3} />
                            <div className="clock-label">نیویورک</div>
                        </div>
                        <div className="clock-item">
                            <Clock value={value4} />
                            <div className="clock-label">دبی</div>
                        </div> */}
          </div>
        </div>
      </section>
    </>
  );
};
export default WorldClocks;
